<mat-card>
    <mat-card-header>
        <mat-card-title>Meraki Network</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-divider></mat-divider>
        <p><b>ID:</b> {{network.id}}</p>
        <p><b>Tags:</b> {{network.tags}}</p>
        <p><b>Organization ID:</b> {{network.organizationId}}</p>
        <p><b>Timezone:</b> {{network.timeZone}}</p>
        <p><b>Type:</b> {{network.type}}</p>
    </mat-card-content>
</mat-card>